// extracted by mini-css-extract-plugin
export default {"dropdownLink":"DropdownLink_dropdownLink__B6+uT","logo":"DropdownLink_logo__E2BY9","right":"DropdownLink_right__-VB6X"};